/*Activar menu fijo al llegar al elemento menu*/
$(document).ready(function () {
    $(document).foundation();
    InitCookiesBanner();
    InitTopicCtrl();
    InitUserMenu();
    $(window).scroll(function () {
        var animationId;
        if ($(this).scrollTop() > 150) {
            HideTopMenuUser();
            var y = 150 - $('.stickyHeader').height();
            var offsetSky = $(this).scrollTop() - y;
            var footerOffset = ($(this).scrollTop() + 155 + 600) - $(document).height() + $('.footer').height();
            //console.log(footerOffset);
            footerOffset = footerOffset > 0 ? footerOffset : 0;
            $('.leftSky, .rightSky').css("top", offsetSky - footerOffset);
            $('.stickyHeader').fadeIn(500);
        } else {
            HideStickyMenuUser();
            $('.leftSky, .rightSky').css("top", 0);
            $('.stickyHeader').fadeOut(500);
        }

        if ($(this).scrollTop() > 300 && $(this).scrollTop() < ($(document).height() - $(window).height() - 1200)) {
            $('.captionShare .sharePost').length ? $('.captionShare .sharePost').addClass('open') : null;
        } else {
            ('.captionShare .sharePost').length ? $('.captionShare .sharePost').removeClass('open') : null;
        }
    });
});
function InitTopicCtrl() {
    $(".btn-themes").click(function () {
        if ($(".tags-module.mobile").hasClass('show')) {
            $(".tags-module.mobile").removeClass('show');
        }
        else {
            $(".tags-module.mobile").addClass('show');
            if ($(".content-body ul").prop('scrollHeight') > $(".content-body ul").height()) {
                $(".content-body").addClass('overflow-tags');
            }
        }
    });
    $(".content-body p .close").click(function () {
        $(".tags-module.mobile").removeClass('show');
    });
}

function InitUserMenu() {
    $(".user-name .button-user").click(function () {
        if ($(event.target).parents(".user-name").hasClass('active')) {
            $(event.target).parents(".user-name").removeClass('active');
        }
        else {
            $(event.target).parents(".user-name").addClass('active');
        }
    });
}

function HideTopMenuUser() {
    $(".desktopHeader .user-name").removeClass('active');
}

function HideStickyMenuUser() {
    $(".stickyHeader .user-name").removeClass('active');
}

function InitCookiesBanner() {
    var cookiesBanner = $(".cookies");
    var cookieRef = "LR_hacp=true";

    if (document.cookie.indexOf(cookieRef) < 0) {
        cookiesBanner.show();
    }

    $(".cookies .action").click(function () {
        document.cookie = cookieRef + "; max-age=31536000; samesite=strict";
        cookiesBanner.hide();
    });
}